import { render, staticRenderFns } from "./Student.Payment.vue?vue&type=template&id=0f5db4ba"
import script from "./Student.Payment.vue?vue&type=script&lang=js"
export * from "./Student.Payment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports